import { MobileDatePicker } from '@mui/x-date-pickers'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { getBranchList, getCatalogList } from '../setting/services/settingApi'
import api from '../../api/api'
import { saveAs } from 'file-saver';
import { Box, Button, CircularProgress, FormControl, Menu, MenuItem, Select, TextField } from '@mui/material'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { REPORT_CONFIG } from './config'

const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function ReportSale() {
    const [branchs, setBranchs] = useState([])
    const [Catalog, setCatalog] = useState([])
    const [CatalogNo, setCatalogNo] = useState('')
    const [BranchNo, setBranchsNo] = useState('')
    const [s, setS] = useState('')
    const [cis, setCis] = useState('')
    const [showCost, setshowCost] = useState('0')
    const [startDate, setStartDate] = useState(dayjs(new Date()).subtract(1, 'day'))
    const [endDate, setEndDate] = useState(dayjs(new Date()))
    const [reports, setReports] = useState([])
    const [loadingDownload, setloadingDownload] = useState(false);
    const [loading, setloading] = useState(false);

    const { profile } = useSelector(state => state.profile)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        getBranchList(null, setBranchs)
        getCatalogList(null, setCatalog)

    }, [])

    const breedClass = [
        {
            value: 'หลัก'
        },
        {
            value: 'ขยาย'
        },
        {
            value: 'จำหน่าย'
        }
    ]

    const seasons = [
        {
            value: 'แล้ง'
        },
        {
            value: 'ฝน'
        }
    ]
    async function getReportPlanSale(body, mode, format) {

        const url = `${REPORT_CONFIG.requests.getReportPlanSale.url}/${mode}`;

        let _params = '';
        let _sdate = '';
        let _edate = '';
        let _s = '';
        let _c = '';
        let _cis = '';
        let _branchNo = '';
        let _showCost = '';
        let _format = '';


        if (body.sdate) {
            _sdate = 'sdate=' + body.sdate;
        }
        if (body.edate) {
            _edate = '&edate=' + body.edate;
        }

        if (body.s) {
            _s = '&s=' + (body.s !== '-' ? body.s : '');
        }
        if (body.c) {
            _c = '&c=' + (body.c !== '-' ? body.c : '');
        }
        if (body.cis) {
            _cis = '&cis=' + (body.cis !== '-' ? body.cis : '');
        }
        if (body.branchNo) {
            _branchNo = '&branchNo=' + (body.branchNo !== '-' ? body.branchNo : '');
        }
        if (body.showCost) {
            _showCost = '&showCost=' + body.showCost;
        }

        if (format) {
            _format = '&format=' + format;
        }
        _params = '?' + _sdate + _edate + _s + _c + _cis + _branchNo + _showCost + _format

        if (mode === 'file') {
            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data

            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'รายงานผลการจำหน่ายเมล็ดพันธุ์พืชผ่านช่องทางต่างๆ ประจำไตรมาส (กมข-20405)');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'รายงานผลการจำหน่ายเมล็ดพันธุ์พืชผ่านช่องทางต่างๆ ประจำไตรมาส  (กมข-20405)');
            }
            setloadingDownload(false)
        } else {
            setloading(true)
            const res = await api.get(url + _params)
            const data = res.data.result
            setReports(data)
            setloading(false)
        }

    }
    async function LoadReport() {
        const body = {
            sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
            edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
            branchNo: BranchNo || undefined,
            s: s || undefined,
            // y: this.form.get('y').value || undefined,
            c: CatalogNo || undefined,
            cis: cis || undefined,
            showCost: showCost === '0' ? '' : showCost || undefined,
        };
        getReportPlanSale(body, 'data')
    }

    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid p-0">
                    <form>
                        <div class="row  no-gutters">

                            <div class="col-12 col-lg-2">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">

                                    <div class="col-12">

                                        <label class="labelInput">วันที่เริ่มต้น</label>


                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={startDate} onChange={e => setStartDate(e)}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: startDate } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>

                                    </div>
                                    <div class="col-12">

                                        <label class="labelInput">วันที่สิ้นสุด</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={endDate} onChange={e => setEndDate(e)}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: endDate } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>

                                    </div>
                                    {profile?.BranchNo?.BranchNo === '00' &&
                                        <div class="col-12">

                                            <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <FormControl variant="standard" fullWidth >
                                                    <Select value={BranchNo || '-'} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                                        <MenuItem value='-'>-</MenuItem>
                                                        {branchs?.map((x) => (
                                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </div>}

                                    <div class="col-12">
                                        <label class="labelInput">ฤดู</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={s || '-'} onChange={e => setS(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {seasons?.map((x) => (
                                                        <MenuItem value={x.value}>{x.value}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>


                                    <div class="col-12">

                                        <label class="labelInput">พันธุ์ข้าว</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={CatalogNo || '-'} onChange={e => setCatalogNo(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {Catalog?.map((x) => (
                                                        <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>


                                    <div class="col-12">
                                        <label class="labelInput">ชั้นพันธุ์</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={cis || '-'} onChange={e => setCis(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {breedClass?.map((x) => (
                                                        <MenuItem value={x.value}>{x.value}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>

                                    </div >

                                    <div class="col-12">
                                        <label class="labelInput">ล็อตที่/ต้นทุน</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={showCost || ''} onChange={e => setshowCost(e.target.value)} disableUnderline >
                                                    <MenuItem value={'0'}>ไม่แสดง</MenuItem>
                                                    <MenuItem value={'1'}>แสดง</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>

                                    <div class="col-12">
                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>

                                    </div >

                                </div >
                            </div >
                            <div class="col-12 col-lg-10">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            รายงานผลการจำหน่ายเมล็ดพันธุ์พืชผ่านช่องทางต่างๆ ประจำไตรมาส (กมข-20405)
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
                                                    edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
                                                    branchNo: BranchNo || undefined,
                                                    s: s || undefined,
                                                    // y: this.form.get('y').value || undefined,
                                                    c: CatalogNo || undefined,
                                                    cis: cis || undefined,
                                                    showCost: showCost === '0' ? '' : showCost || undefined,
                                                };
                                                // setFormat('')
                                                getReportPlanSale(body, 'file')

                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
                                                    edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
                                                    branchNo: BranchNo || undefined,
                                                    s: s || undefined,
                                                    // y: this.form.get('y').value || undefined,
                                                    c: CatalogNo || undefined,
                                                    cis: cis || undefined,
                                                    showCost: showCost === '0' ? '' : showCost || undefined,
                                                };
                                                // setFormat('pdf')
                                                getReportPlanSale(body, 'file', 'pdf')

                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div >

                                </div >
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="report col-12">
                                        <div class="table-responsive-sm" style={{ height: 'auto' }}>
                                            <table class="table table-bordered table-sm table-hover">
                                                <thead class="sticky-thead">
                                                    <tr>
                                                        <th scope="col" rowspan="3">ที่</th>
                                                        <th scope="col" rowspan="3">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                                        <th scope="col" rowspan="3">พันธุ์</th>
                                                        <th scope="col" rowspan="3">ชั้นพันธุ์</th>
                                                        <th scope="col" rowspan="3">ฤดู</th>
                                                        <th scope="col" rowspan="3">ปี</th>
                                                        <th scope="col" rowspan="3">ล็อตที่</th>
                                                        <th scope="col" rowspan="3">ต้นทุน</th>
                                                        <th scope="col" colspan="5">เมล็ดพันธุ์คงคลัง (กิโลกรัม)</th>
                                                        <th scope="col" colspan="15">ผลการจำหน่ายผ่านช่องทางต่างๆ (กิโลกรัม)</th>
                                                        <th scope="col" rowspan="3">คงเหลือ (กิโลกรัม)</th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" rowspan="2">คงเหลือยกมา</th>
                                                        <th scope="col" rowspan="2">รับเข้าคลัง</th>
                                                        <th scope="col" rowspan="2">รับโอน</th>
                                                        <th scope="col" rowspan="2">โอนให้</th>
                                                        <th scope="col" rowspan="2">รวม</th>
                                                        <th scope="col" colspan="3">ส่วนราชการ</th>
                                                        <th scope="col" colspan="2">เกษตรกรทำแปลง</th>
                                                        <th scope="col" colspan="4">ตัวแทนจำหน่าย</th>
                                                        <th scope="col" colspan="2">สถาบัน/กลุ่มเกษตรกร/ผู้ซื้อทั่วไป</th>
                                                        <th scope="col" rowspan="2">ลดราคาเฉพาะกิจ</th>
                                                        <th scope="col" rowspan="2">ขายทอดตลาด</th>
                                                        <th scope="col" rowspan="2">รวม</th>
                                                        <th scope="col" rowspan="2">เป็นเงิน (บาท)</th>

                                                    </tr>
                                                    <tr>
                                                        <th scope="col">โครงการ</th>
                                                        <th scope="col">ประสบภัย</th>
                                                        <th scope="col">อื่นๆ</th>
                                                        <th scope="col">ราคาเต็ม</th>
                                                        <th scope="col">ลด 5 %</th>
                                                        <th scope="col">ราคาเต็ม</th>
                                                        <th scope="col">ลด 5 %</th>
                                                        <th scope="col">ลด 7 %</th>
                                                        <th scope="col">ลด 8 %</th>
                                                        <th scope="col">ราคาเต็ม</th>
                                                        <th scope="col">ลด 5 %</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reports?.map((report, i) => (
                                                        <tr class="cp">
                                                            <td>{i + 1}</td>
                                                            <td>{report?.BranchName}</td>
                                                            <td>{report?.CatalogName}</td>
                                                            <td>{report?.ClassName}</td>
                                                            <td class="text-center">
                                                                <span style={{ fontWeight: "bold" }}>{report?.Season}
                                                                </span>
                                                            </td>
                                                            <td>{report?.Year}</td>
                                                            <td class="text-center">{showCost === '1' ? report?.Lot : '-'}</td>
                                                            <td class="text-center">{showCost === '1' ? (report?.CostPrice) : '-'}</td>
                                                            <td class="text-center">{report?.Stock?.Initial.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Stock?.Receive.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Stock?.In.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Stock?.Out.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Stock?.Total.toLocaleString()}</td>

                                                            <td class="text-center">{report?.Sale?.Government?.Campaign.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Government?.Disaster.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Government?.Other.toLocaleString()}</td>

                                                            <td class="text-center">{report?.Sale?.Transplant?.Discount0.toLocaleString()}
                                                            </td>
                                                            <td class="text-center">{report?.Sale?.Transplant?.Discount5.toLocaleString()}
                                                            </td>


                                                            <td class="text-center">{report?.Sale?.Agent?.Discount0.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Agent?.Discount5.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Agent?.Discount7.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Agent?.Discount8.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Customer?.Discount0.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Customer?.Discount5.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Special.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Auction.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Sale?.Total.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(report?.Sale?.TotalPrice).toFixed(2)
                                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{report?.Balance.toLocaleString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div >
                                </div >
                                {
                                    reports.length === 0 &&
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div >

                        </div >

                    </form >
                </div >
            </Page >
        </div >
    )
}
